import { FC } from 'react';
import { useStyles } from './styles';
import { ResetPasswordForm } from 'components/Forms';
import { observer } from 'mobx-react-lite';
import { ReactComponent as LogoIcon } from 'assets/logo.svg';

const AdminResetPassword: FC = observer(() => {
  const classes = useStyles();

  return (
    <>
      <LogoIcon style={{ marginLeft: '40px', width: '140px', height: '52px' }} className={classes.logo} />
      <ResetPasswordForm userType='admin' />
    </>
  );
});

export default AdminResetPassword;
